import { styled } from 'parkdepot-shared/theme'

const ButtonCardsContainer = styled('div', () => ({
    marginTop: '1.2rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.8rem'
}))

export const HourlyDisabledWrapper = styled('div', () => ({
    color: '#D92D20',
    textAlign: 'center',
    marginTop: '-1.5rem',
    lineHeight: '1.8rem'
}))

export const ButtonCardDescription = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall
}))

export const ButtonCardIcon = styled('i', () => ({
    fontSize: '1.6rem'
}))

export const ButtonCardTitle = styled('span', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    fontWeight: 700
}))

export default ButtonCardsContainer
